'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoStripeIcon = function LogoStripeIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M3.563 15.313c-.688-.25-1.063-.438-1.063-.75 0-.25.188-.375.563-.375.75 0 1.438.25 1.938.5l.313-1.75c-.375-.188-1.188-.5-2.313-.5-.813 0-1.5.188-1.938.563-.5.438-.75 1-.75 1.75 0 1.25.75 1.813 2.063 2.25.813.313 1.063.5 1.063.875 0 .313-.25.438-.75.438-.563 0-1.563-.25-2.188-.625l-.313 1.75c.563.313 1.563.625 2.625.625.875 0 1.563-.188 2.063-.563.5-.438.75-1.063.75-1.813 0-1.313-.75-1.875-2.063-2.375zm7-2.75h-1.5v-2.125l-2 .313-.313 1.813-.688.125-.313 1.625h1v3.375c0 .938.25 1.5.688 1.875.375.313.938.5 1.75.5.563 0 .938-.125 1.188-.188v-1.813c-.125 0-.438.125-.688.125-.438 0-.625-.25-.625-.813v-3.063h1.188zm4.625-.063h-.438c-.625 0-1.188.313-1.375.938l-.188-.875h-2v7.375H13.5v-4.813c.313-.375.75-.438 1.313-.438h.375v-2.188zm1.75-3.125c-.688 0-1.25.563-1.25 1.188 0 .688.563 1.25 1.25 1.25s1.25-.5 1.25-1.25c0-.688-.563-1.188-1.25-1.188zm1.187 10.563v-7.375H15.75v7.375zm6.688-6.688c-.438-.563-1-.813-1.75-.813-.688 0-1.25.25-1.813.875l-.125-.75h-2.063v10.063l2.313-.375v-2.375c.375.125.75.188 1.063.188.563 0 1.438-.188 2.125-.875.625-.688.938-1.75.938-3.188 0-1.188-.25-2.188-.688-2.75zm-2 4.5c-.188.375-.438.563-.813.563-.188 0-.438-.063-.625-.125v-3.5c.438-.438.75-.5.875-.5.625 0 .938.688.938 1.938 0 .688-.125 1.25-.375 1.625zm8.625-4.312c-.5-.688-1.25-1-2.25-1-2 0-3.188 1.438-3.188 3.813 0 1.313.313 2.313.938 2.938.625.563 1.438.875 2.563.875 1 0 1.875-.25 2.5-.625l-.25-1.625c-.625.313-1.25.5-2 .5-.5 0-.813-.125-1-.313-.25-.188-.375-.563-.438-1h3.875v-.813c0-1.188-.25-2.125-.75-2.75zm-3.125 2.125c.063-1.063.313-1.563.875-1.563.5 0 .813.5.813 1.563z' })
    );
};

exports.default = LogoStripeIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/LogoStripeIcon.js
// module id = 638
// module chunks = 0